module.exports = __webpack_public_path__ + "img/img64.7d7b362c.svg";